module.exports = __webpack_public_path__ + "img/scene12.e797ba96.gif";